import React from 'react';
import Utils from '../../lib/Utils';

class ArRequestForm extends React.Component {

  state = {
    movies: 1,

    yourname: this.props.data.username,
    school: this.props.data.school || this.props.data.albums[0].code,
    release_date_type: 'nouhinbi',
    release_date: '',
    lead_page_type: 'tobira',
    lead_page_other: '',

    page_1_title: '', page_1_photo: '', page_1_movie: '', page_1_time: '',
    page_2_title: '', page_2_photo: '', page_2_movie: '', page_2_time: '',
    page_3_title: '', page_3_photo: '', page_3_movie: '', page_3_time: '',
    page_4_title: '', page_4_photo: '', page_4_movie: '', page_4_time: '',
    page_5_title: '', page_5_photo: '', page_5_movie: '', page_5_time: '',
    page_6_title: '', page_6_photo: '', page_6_movie: '', page_6_time: '',
    page_7_title: '', page_7_photo: '', page_7_movie: '', page_7_time: '',
    page_8_title: '', page_8_photo: '', page_8_movie: '', page_8_time: '',
    page_9_title: '', page_9_photo: '', page_9_movie: '', page_9_time: '',
    page_10_title: '', page_10_photo: '', page_10_movie: '', page_10_time: '',
    page_11_title: '', page_11_photo: '', page_11_movie: '', page_11_time: '',
    page_12_title: '', page_12_photo: '', page_12_movie: '', page_12_time: '',
    page_13_title: '', page_13_photo: '', page_13_movie: '', page_13_time: '',
    page_14_title: '', page_14_photo: '', page_14_movie: '', page_14_time: '',
    page_15_title: '', page_15_photo: '', page_15_movie: '', page_15_time: '',

    bikoh: '',

    yourname_validate_message:null,
    release_date_validate_message:null,
    lead_page_other_validate_message:null,
    page_1_validate_message:null,
    page_2_validate_message:null,
    page_3_validate_message:null,
    page_4_validate_message:null,
    page_5_validate_message:null,
    page_6_validate_message:null,
    page_7_validate_message:null,
    page_8_validate_message:null,
    page_9_validate_message:null,
    page_10_validate_message:null,
    page_11_validate_message:null,
    page_12_validate_message:null,
    page_13_validate_message:null,
    page_14_validate_message:null,
    page_15_validate_message:null,
  }

  getData = () => {
    let formData = {
      doc_date: (new Date()).toLocaleDateString('sv-SE'),
      yourname: this.state.yourname,
      customerName: this.props.data.customerName,
      albumName: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      release_date_type: this.state.release_date_type,
      release_date: this.state.release_date,
      lead_page_type: this.state.lead_page_type,
      lead_page_other: this.state.lead_page_other,
      bikoh: this.state.bikoh,
    };
    for (let i = 1; i <= 15; i++) {
      if (this.state.movies >= i) {
        formData['page_'+i+'_title'] = this.state['page_'+i+'_title'];
        formData['page_'+i+'_photo'] = this.state['page_'+i+'_photo'];
        formData['page_'+i+'_movie'] = this.state['page_'+i+'_movie'];
        formData['page_'+i+'_time'] = this.state['page_'+i+'_time'];
      }
      else {
        formData['page_'+i+'_title'] = '';
        formData['page_'+i+'_photo'] = '';
        formData['page_'+i+'_movie'] = '';
        formData['page_'+i+'_time'] = '';
      }
    }
    return {
      schoolCode: this.state.school,
      hinmei: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      filename: "AR申請_" + Utils.getHyphenationDate(),
      form: formData
    };
  }

  validation = () => {
    let newState = {};

    newState['yourname_validate_message'] = (()=>{
      if (this.state.yourname_validate_message === '') return '申請者のお名前を入力してください。';
      return null;
    })();

    newState['release_date_validate_message'] = (()=>{
      if (this.state.release_date_type === 'nouhingo') {
        if (this.state.release_date === '') return '動画公開日を指定してください。';
        if (!this.state.release_date.match(/^\d{4}-\d{2}-\d{2}$/)) return '動画公開日をYYYY-MM-DDの形式で入力してください。';
        if (this.state.release_date < (new Date()).toLocaleDateString('sv-SE')) return '動画公開日が過去の日付です。';
      }
      return null;
    })();

    newState['lead_page_other_validate_message'] = (()=>{
      if (this.state.lead_page_type === 'other') {
        if (this.state.lead_page_other === '') return '動画の説明ページを指定してください。';
      }
      return null;
    })();

    for (let i = 1; i <= 15; i++) {
      newState['page_'+i+'_validate_message'] = (()=>{
        if (this.state.movies >= i) {
          if (this.state['page_'+i+'_title'] === '') return 'ページタイトルを指定してください。';
          if (this.state['page_'+i+'_photo'] === '') return '写真ファイル名を指定してください。';
          if (this.state['page_'+i+'_movie'] === '') return '動画ファイル名を指定してください。';
          if (this.state['page_'+i+'_time'] === '') return '動画ファイルの長さを指定してください。';
          if (parseInt(this.state['page_'+i+'_time'], 10) <= 0) return '動画ファイルの長さを指定してください。';
        }
        return null;
      })();
    }

    this.setState(newState);
    this.props.changeValidate(Object.values(newState).every(v=>v===null));
  }

  handleClickAddMovie = e => {
    e.preventDefault();
    if (this.state.movies >= 15) return;
    let movies = this.state.movies;
    movies++;
    this.setState({
      movies: movies
    }, () =>{
      this.validation();
    });
  }
  handleClickRemoveMovie = e => {
    e.preventDefault();
    if (this.state.movies <= 1) return;
    let movies = this.state.movies;
    movies--;
    this.setState({
      movies: movies
    }, () =>{
      this.validation();
    });
  }

  handleChangeValue = e => {
    let newState = {};
    newState[e.target.name] = e.target.value.trim();
    this.setState(newState, () =>{
      this.validation();
    });
  }

  handleMouseDownDatePicker = e => {
    let name = e.target.name;
    this.props.openDatePicker(e.target, value => {
      let newState = {};
      newState[name] = value;
      this.setState(newState, () =>{
        this.validation();
      });
    })
  }

  renderForm = () => {
    return (<form ref={ref=>{this.form=ref}}>

      <div className="formBlock titleBlock">
        <div className="titleBlock-wrap">
          <h2>AR動画ご利用申し込み</h2>
          <div>AR動画ご利用の申し込みフォームです。</div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">対象の学校</div>
        <div className="formBlock-input">
          <select name="school" value={this.state.school} onChange={this.handleChangeValue}>{
            this.props.data.albums.map(a => {
              return <option key={a.code} value={a.code}>{a.hinmei}</option>
            })
          }</select>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">申請者お名前</div>
        <div className="formBlock-input">
          <input name="yourname" value={this.state.yourname} onChange={this.handleChangeValue}/>
        </div>
        {!this.state.yourname_validate_message?null
        :<div className="formBlock-error">{this.state.yourname_validate_message}</div>}
      </div>

      <div className="formBlock">
        <div className="formBlock-title">動画の公開日</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="release_date_type" type="radio" value="nouhinbi" checked={this.state.release_date_type === 'nouhinbi'} onChange={this.handleChangeValue}/>
              納品日
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="release_date_type" type="radio" value="nouhingo" checked={this.state.release_date_type === 'nouhingo'} onChange={this.handleChangeValue}/>
              納品後
            </label>
            {this.state.release_date_type !== 'nouhingo'?null
            :(
              <div className="formBlock">
                <label>納品後の公開日</label>
                <div className="formBlock-input">
                  <input name="release_date" onMouseDown={this.handleMouseDownDatePicker} 
                    value={this.state.release_date} onChange={this.handleChangeValue} required pattern="^\d{4}-\d{2}-\d{2}$"/>
                </div>

                {!this.state.release_date_validate_message?null
                  :<div className="formBlock-error">{this.state.release_date_validate_message}</div>}
              </div>)
            }

          </div>
        </div>
      </div>
      

      <div className="formBlock">
        <div className="formBlock-title">動画利用説明を配置するページ</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="lead_page_type" type="radio" value="tobira" checked={this.state.lead_page_type === 'tobira'} onChange={this.handleChangeValue}/>
              扉
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="lead_page_type" type="radio" value="urami" checked={this.state.lead_page_type === 'urami'} onChange={this.handleChangeValue}/>
              裏見返し
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="lead_page_type" type="radio" value="other" checked={this.state.lead_page_type === 'other'} onChange={this.handleChangeValue}/>
              その他
            </label>
            {
              this.state.lead_page_type !== 'other' ? null
              : (<div className="formBlock">
                  <label>その他のページ</label>
                  <div className="formBlock-input">
                    <input name="lead_page_other" value={this.state.lead_page_other} onChange={this.handleChangeValue} required/>
                  </div>
                  {!this.state.lead_page_other_validate_message?null
                    :<div className="formBlock-error">{this.state.lead_page_other_validate_message}</div>}
                </div>)
            }

          </div>
        </div>
      </div>

      {(()=>{
        let movies = [];
        for (let i = 1; i <= this.state.movies; i++) {
          movies.push(
            <div className="formBlock" key={i}>
              <div className="formBlock-title">動画 {i}</div>
              <div className="formBlock-input">
                <label>AR動画を設定するページのタイトル</label>
                <input name={"page_"+i+"_title"} value={this.state["page_"+i+"_title"]} onChange={this.handleChangeValue} required/>
                <label>AR動画を設定する写真のファイル名</label>
                <input name={"page_"+i+"_photo"} value={this.state["page_"+i+"_photo"]} onChange={this.handleChangeValue} required/>
                <label>動画ファイル名</label>
                <input name={"page_"+i+"_movie"} value={this.state["page_"+i+"_movie"]} onChange={this.handleChangeValue} required/>
                <label>動画の長さ（分）</label>
                <input name={"page_"+i+"_time"} value={this.state["page_"+i+"_time"]} onChange={this.handleChangeValue} required pattern="^\d+$"/>
              </div>

              <div className="formBlock-buttons">
                {i===1||i!==this.state.movies?null
                :<button onClick={this.handleClickRemoveMovie}>動画の削除</button>
                }
                {i!==this.state.movies?null
                :<button onClick={this.handleClickAddMovie} disabled={this.state.movies>=15}>動画の追加</button>
                }
              </div>

              {!this.state['page_'+i+'_validate_message']?null
                :<div className="formBlock-error">{this.state['page_'+i+'_validate_message']}</div>}
            </div>
          );
        }
        return movies;
      })()}

      <div className="formBlock">
        <div className="formBlock-title">ご連絡事項</div>
        <div className="formBlock-input">
          <textarea name="bikoh" value={this.state.bikoh} onChange={this.handleChangeValue}></textarea>
        </div>
      </div>



    </form>)
  }

  renderConfirm = () => {
    return (
      <div>
        <div className="formBlock titleBlock">
          <div className="titleBlock-wrap">
            <h2>AR動画の申し込み</h2>
            <div>内容をよくご確認の上、ご申請ください。</div>
          </div>
        </div>
        <div className="confirm">
          <div className="confirm-row">
            <label>学校</label>
            <span>{this.props.data.albums.find(a=>a.code===this.state.school).hinmei}</span>
          </div>
          <div className="confirm-row">
            <label>申請者お名前</label>
            <span>{this.state.yourname}</span>
          </div>
          <div className="confirm-row">
            <label>動画の公開日</label>
            <span>{this.state.release_date_type === 'nouhingo' ? '納品後 '+this.state.release_date : '納品日'}</span>
          </div>
          <div className="confirm-row">
            <label>動画説明のページ</label>
            <span>{(()=>{
              switch (this.state.lead_page_other) {
                case 'urami': return '裏見返し';
                case 'other': return 'その他（'+this.state.lead_page_other+'）';
                default: return '扉';
              }
            })()}</span>
          </div>

          {(()=>{
            let movies = [];
            for (let i = 1; i <= this.state.movies; i++) {
              movies.push(
                <div key={i}>
                  <div className="confirm-row"><label>動画 {i}</label></div>
                  <div className="confirm-row" data-indent="1">
                    <label>ページタイトル</label>
                    <span>{this.state['page_'+i+'_title']}</span>
                  </div>
                  <div className="confirm-row" data-indent="1">
                    <label>写真ファイル名</label>
                    <span>{this.state['page_'+i+'_photo']}</span>
                  </div>
                  <div className="confirm-row" data-indent="1">
                    <label>動画ファイル名</label>
                    <span>{this.state['page_'+i+'_movie']}</span>
                  </div>
                  <div className="confirm-row" data-indent="1">
                    <label>動画の長さ（分）</label>
                    <span>{this.state['page_'+i+'_time']}</span>
                  </div>
                </div>
              );
            }
            return movies;
          })()}

          <div className="confirm-row">
            <label>備考</label>
            <span>{this.state.bikoh}</span>
          </div>
          
        </div>
      </div>
    )
  }

  render () {
    switch (this.props.progress) {
      case 'form': return this.renderForm();
      case 'confirm': return this.renderConfirm();
      default: return null;
    }
  }
}
export default ArRequestForm;